import type { OrgVenueApi, OrgVenueOption } from '../types'

const clean = (value?: string | null): string => value?.trim() ?? ''

/**
 * An organization's venues → the Location filter's rows, read by name ("Rink 2"
 * before "Rink 10"; the API's order is arbitrary). The city follows the name so
 * two same-named rinks can be told apart, and is searchable with it.
 */
export const toOrgVenueOptions = (venues: OrgVenueApi[]): OrgVenueOption[] =>
  venues
    .map((venue) => {
      const name = clean(venue.name_full) || clean(venue.name)
      const city = clean(venue.address?.city)
      return {
        value: venue.id,
        name,
        label: city ? `${name} · ${city}` : name,
      }
    })
    .sort(
      (a, b) =>
        a.name.localeCompare(b.name, undefined, {
          sensitivity: 'base',
          numeric: true,
        }) || a.value.localeCompare(b.value)
    )
    .map(({ value, label }) => ({ value, label }))

/** The Location select's search: anywhere in the name or city, any case. */
export const matchesVenueOption = (
  input: string,
  option: OrgVenueOption | undefined
): boolean =>
  (option?.label ?? '').toLowerCase().includes(input.trim().toLowerCase())
